import { BuyerPermissions } from '@/types';

export type BuyerPermissionsReducer = Readonly<BuyerPermissions> | null;

const buyerData = (state = null, action) => {
    switch (action.type) {
        case 'SET_BUYER_PERMISSIONS':
            return action.data;
        case 'CLEAR_BUYER_PERMISSIONS':
            return null;
        default:
            return state;
    }
};

export default buyerData;
